import React from 'react';
import TransactionInProgress from '@linkexchange/components/src/TransactionInProgress';

const ConfirmationToUseTokens = () => (
  <TransactionInProgress>Receiving confirmation to use your tokens by our contract</TransactionInProgress>
);

export default ConfirmationToUseTokens;
